var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "108px",
    viewBox: "0 0 147 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locations-Feature",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Pool-of-Questions-/-Manage-Subjects-/-Empty-State",
    transform: "translate(-683.000000, -295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(683.000000, 295.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143,75.0463221 L107.482912,105 L40.9360275,101.428756 C32.1347597,101.428756 25,94.6677396 25,86.3275295 L25,89.5807653 C25,81.2405551 32.1347597,74.4795386 40.9360275,74.4795386 L143,47 C143,47 137.080095,55.7736057 137.080095,63.8276548 C137.080095,71.8817039 143,75.0463221 143,75.0463221",
    id: "Fill-67",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-68",
    fill: "#898F9E",
    points: "11 72.2503089 54.6798016 45 144 48.3156776 107.337384 73.4799283 105.128624 75 11 72.2503089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,105 L17.0499058,101.79087 C8.1858499,101.79087 1,95.1219891 1,86.895435 C1,78.6688809 8.1858499,72 17.0499058,72 L108,75.2089024 C108,75.2089024 103.71968,82.1600447 103.71968,90.1043374 C103.71968,98.0486301 108,105 108,105",
    id: "Fill-69",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,90.8401997 C4.26827838,98.1274034 10.8404796,103.680399 18.7590684,103.680399 L107,107 C106.000765,104.230684 105.057824,100.592968 105.057824,96.7277931 C105.057824,95.857746 105.107082,94.9994722 105.191525,94.1598003 C105.107082,93.3201283 105.057824,92.461619 105.057824,91.5915719 C105.057824,87.726632 106.000765,84.0889169 107,81.3196005 L18.7590684,78 C10.8404796,78 4.26827838,83.5529961 3,90.8401997",
    id: "Fill-70",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,90.8401997 C4.26827838,98.1274034 10.8404796,103.680399 18.7590684,103.680399 L107,107 C106.000765,104.230684 105.057824,100.592968 105.057824,96.7277931 C105.057824,95.857746 105.107082,94.9994722 105.191525,94.1598003 C105.107082,93.3201283 105.057824,92.461619 105.057824,91.5915719 C105.057824,87.726632 106.000765,84.0889169 107,81.3196005 L18.7590684,78 C10.8404796,78 4.26827838,83.5529961 3,90.8401997",
    id: "Fill-71",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3859354,79 C3.25375606,79.2439053 3.12558215,79.4894319 3,79.7361167 L109.976439,83 L110,82.2529967 L3.3859354,79",
    id: "Fill-72",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-73",
    fill: "#C6C7C5",
    points: "107.97678 84 3 80.7448626 3.02322017 80 108 83.2551374 107.97678 84"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-74",
    fill: "#C6C7C5",
    points: "107.97667 87 3 83.7446747 3.0235629 83 108 86.2550944 107.97667 87"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-75",
    fill: "#C6C7C5",
    points: "107.976559 90 3 86.7447177 3.02390935 86 108 89.2552823 107.976559 90"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-76",
    fill: "#C6C7C5",
    points: "107.976672 91 4 87.7446747 4.02379436 87 108 90.2553253 107.976672 91"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-77",
    fill: "#C6C7C5",
    points: "107.974217 94 4 90.7446747 4.0239081 90 108 93.2553253 107.974217 94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,93 C4.0713426,93.158732 4.13689441,93.3209348 4.19155952,93.4891537 C4.22074513,93.578238 4.25456337,93.6670909 4.28513877,93.7561752 L105.976837,97 L106,96.2537745 L4,93",
    id: "Fill-78",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,94 C6.11213941,94.2558045 6.23054749,94.5099796 6.35452771,94.762991 L106.976783,98 L107,97.2491126 L6,94",
    id: "Fill-79",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,97 C7.15523021,97.2610482 7.31582928,97.5188098 7.48203064,97.7737543 L106.974323,101 L107,100.242913 L7,97",
    id: "Fill-80",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,98 C8.20833938,98.2682347 8.42157813,98.5317177 8.64158265,98.7883108 L105.97667,102 L106,101.233547 L8,98",
    id: "Fill-81",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.311757,48 C140.826459,48.2196256 141.476286,50.4158813 141.476286,50.4158813 L126.54197,61.8354627 C126.54197,61.8354627 110.635252,75.6706881 106.970046,76.8613149 C103.307176,78.0519417 17.2591976,73.5972899 17.2591976,73.5972899 C9.23758368,73.6103346 2.71571262,79.9495921 2.71571262,87.7396591 C2.71571262,95.5377901 9.25090745,101.882028 17.2837414,101.882028 L17.3332965,101.882977 L107.051858,105.207008 L141.759124,75.0983809 C142.329475,74.6036304 143.187339,74.6717001 143.67354,75.2501739 C144.162078,75.8284106 144.094291,76.6981374 143.52394,77.1928879 L108.012573,108 L17.2587301,104.637547 C7.7394771,104.624502 0,97.0490798 0,87.7396591 C0,78.4219373 7.75350213,70.8415344 17.2837414,70.8415344 L17.3332965,70.8424831 L105.43898,74.3531718 L139.311757,48",
    id: "Fill-82",
    fill: "#B1B6C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,53.7272084 L70.2714417,78 L121.688376,56.6514731 C128.487367,56.6514731 134,51.1727772 134,44.4141925 L134,47.0506798 C134,40.2920951 128.487367,34.8133992 121.688376,34.8133992 L11,31 C11,31 15.5733567,38.1098219 15.5733567,44.636418 C15.5733567,51.1627817 11,53.7272084 11,53.7272084",
    id: "Fill-83",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,78 L137.306685,57.6969579 C141.468783,56.2417623 145.595608,53.6657773 145.595608,46.8429489 C145.595608,40.0201205 147.9847,32 141.148983,32 L71,53.2919462 C71,53.2919462 74.3014606,59.0571118 74.3014606,65.6459731 C74.3014606,72.2348344 71,78 71,78",
    id: "Fill-84",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.824766,48.8199651 C142.852715,54.6790347 139.427284,54.3827513 135.959994,57.803307 L72,78 C72.7650828,75.7732853 73.488307,72.8485748 73.488307,69.7407758 C73.488307,69.0413681 73.4510993,68.3511383 73.3859859,67.6759698 C73.4510993,67.0008013 73.488307,66.3108068 73.488307,65.6111637 C73.488307,62.5033647 72.7650828,59.5786542 72,57.3519395 L139.597044,36 C143.871275,38.1921208 144.357301,42.7681584 143.824766,48.8199651",
    id: "Fill-85",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.877039,53.0705678 C142.56712,51.436844 143.16426,49.770228 143.680078,48.0780555 C144.618773,42.0803205 143.649872,36.4929094 138.64737,36 L72,57.2376992 C72.7644326,59.4767338 73.4870421,62.4176259 73.4870421,65.5426195 C73.4870421,66.2461336 73.4498661,66.9399456 73.384808,67.6188496 C73.4498661,68.2977537 73.4870421,68.9918023 73.4870421,69.6950797 C73.4870421,72.8200734 72.7644326,75.7609655 72,78 L135.905636,57.691564 C138.124581,55.487788 140.327262,54.8164562 141.877039,53.0705678",
    id: "Fill-86",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-87",
    fill: "#C6C7C5",
    points: "68.1724355 57 68 56.4425753 142.827564 35 143 35.5574247 68.1724355 57"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-88",
    fill: "#C6C7C5",
    points: "69.1723595 58 69 57.4467221 143.830002 36 144 36.5532779 69.1723595 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-89",
    fill: "#C6C7C5",
    points: "69.1746381 61 69 60.451025 143.827722 39 144 39.548975 69.1746381 61"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-90",
    fill: "#C6C7C5",
    points: "69.1745612 64 69 63.4055093 143.827798 40 144 40.5944907 69.1745612 64"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-91",
    fill: "#C6C7C5",
    points: "69.1744789 65 69 64.4098341 143.825521 41 144 41.5899236 69.1744789 65"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-92",
    fill: "#C6C7C5",
    points: "69.1767534 67 69 66.4143523 143.823247 43 144 43.5858884 69.1767534 67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,45.3657881 L145.889186,45 L71,68.4185643 L71.1768312,69 L145.929268,45.6244695 C145.952845,45.5379236 145.97878,45.4525731 146,45.3657881",
    id: "Fill-93",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,47 L71,70.4179104 L71.1760767,71 L143.784538,47.7068401 C143.856359,47.4712268 143.930496,47.2365712 144,47",
    id: "Fill-94",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,50 L71,73.4148985 L71.1783063,74 L143.744271,50.7248128 C143.828732,50.4832085 143.917885,50.2428087 144,50",
    id: "Fill-95",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,51 L71,74.4105127 L71.1807689,75 L142.704196,51.7434144 C142.805145,51.496257 142.903746,51.2486141 143,51",
    id: "Fill-96",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-97",
    fill: "#898F9E",
    points: "140 30.4318962 74.2585312 14 10 29.1057229 68.4958206 53 140 30.4318962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9402006,40 L35.1348115,32.0220297 C28.9852218,32.0220297 24,26.7437474 24,20.2326394 C24,13.7215314 28.4087857,9.75548414 35.1348115,8.44324903 L75.6678622,0 L132,6.65083135 L98.0027067,14.77947 C98.0027067,14.77947 77.6338915,16.3874528 76.6508769,21.7414187 L83.9402006,40",
    id: "Fill-98",
    fill: "#B1B6C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,28.0225762 L83.6050808,40 C78.852194,40 75,34.9767442 75,28.780237 C75,22.5837298 78.852194,17.5602376 83.6050808,17.5602376 L130,8 C130,8 128.905312,13.2360155 128.905312,19.2199994 C128.905312,25.2037469 130,28.0225762 130,28.0225762",
    id: "Fill-99",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,21 L129.443928,12.0965567 C129.723137,10.2041319 130,9 130,9 L82.8652618,17.7947082 C80.4180752,17.7947082 77.586096,19.0895252 76,21",
    id: "Fill-100",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2970141,21.454208 C76.1932949,21.6318312 76.0942902,21.8143884 76,22 L129.943426,12.5032658 C129.962284,12.3326911 129.981142,12.164231 130,12 L76.2970141,21.454208",
    id: "Fill-101",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,36.6101599 C77.1135613,36.7442086 77.2318543,36.8734228 77.3525132,37 L130,25.45203 C129.976341,25.3080924 129.955049,25.1544857 129.933756,25 L77,36.6101599",
    id: "Fill-102",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,33.5392782 L75.1036604,34 L129,22.4771599 C128.990576,22.3194003 128.981153,22.1643804 128.971729,22 L75,33.5392782",
    id: "Fill-103",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,35.5814109 C76.0791184,35.7236153 76.1628908,35.8629221 76.2466632,36 L129,24.4629444 C128.983711,24.3131617 128.969749,24.1578068 128.955787,24 L76,35.5814109",
    id: "Fill-104",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4941725,39 L130,27.4438132 C129.969697,27.3043977 129.939394,27.15646 129.909091,27 L79,38.647965 C79.1608392,38.7709915 79.3263403,38.8894291 79.4941725,39",
    id: "Fill-105",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1746819,24.4486709 C75.1141255,24.630068 75.0558982,24.8136803 75,25 L128.955747,14.5257317 C128.969722,14.3482726 128.983696,14.1727826 129,14 L75.1746819,24.4486709",
    id: "Fill-106",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,31.5255126 L75.1007463,32 L129,20.4942088 C128.995314,20.3333855 128.995314,20.1662232 128.990628,20 L75,31.5255126",
    id: "Fill-107",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0115607,28.5307237 C75.0069364,28.5846609 75.0023121,28.6383705 75,28.6927629 L75.0624277,29 L128.981503,18.4831589 C128.988439,18.3211197 128.993064,18.1599909 129,18 L75.0115607,28.5307237",
    id: "Fill-108",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.087978,25.4863914 C75.0555651,25.6562574 75.0254673,25.8273029 75,26 L128.967587,15.502756 C128.979163,15.3335979 128.988424,15.1660912 129,15 L75.087978,25.4863914",
    id: "Fill-109",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,29.5518469 L75.0954475,30 L128.995344,19.468071 C128.997672,19.3113834 128.997672,19.1553597 129,19 L75,29.5518469",
    id: "Fill-110",
    fill: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1219606,79 L10.6668419,54.7376054 C10.1181588,54.5137296 9.85565345,53.889492 10.0804237,53.3429922 C10.3054283,52.7964925 10.9319254,52.5343313 11.4808428,52.7591409 L70.2274315,76.7322945 C74.6079896,75.3995448 116.744786,62.5730252 131.206019,57.7892264 C131.71931,57.6190435 132.216196,57.4565642 132.696674,57.2994543 C140.243703,54.8312177 143.065636,53.9074674 144.403944,46.2987248 C145.320369,41.082115 145.303963,34.6249672 140.119482,33.2149465 L70.9797906,53.9912749 C70.4125915,54.1623917 69.8149231,53.8418687 69.6438258,53.2766932 C69.4727286,52.7112843 69.7938289,52.1145934 70.361028,51.9439435 L140.056199,31 L140.335111,31.064198 C145.866474,32.3406869 148.062613,37.8820217 146.51805,46.6673378 C144.959424,55.5390294 141.085126,56.806414 133.367,59.3311448 C132.888866,59.4875543 132.394324,59.6490998 131.883376,59.8185824 C116.674472,64.8500686 70.9469774,78.7490443 70.487593,78.8888792 L70.1219606,79",
    id: "Fill-111",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9565584,54 C68.8349315,54 68.7133046,53.9782979 68.5940167,53.9329646 L8.68224019,31.0861786 C8.14123436,30.8797673 7.86500094,30.2607747 8.06521754,29.7030302 C8.26520024,29.1455268 8.86608394,28.8612291 9.40662197,29.0669169 L69.3191002,51.9137029 C69.8594043,52.1201142 70.1354038,52.7391068 69.9342516,53.2968513 C69.779879,53.7311349 69.3799136,54 68.9565584,54",
    id: "Fill-112",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20.6909162 L24,20.6909162 C24,27.1894896 28.9152386,32.4576107 34.9784996,32.4576107 L80.5565867,40 C78.7014306,39.2051101 75.5624693,36.9196855 74.2879169,30.4097233 C73.6286657,27.0300468 74.5400516,24.3276536 75.9395148,22.2681451 L75.9117568,22.1967909 C76.1153151,21.0785994 77.1562382,20.1247315 78.6736726,19.3145017 C80.4224233,17.8737056 82,17.174342 82,17.174342 L29.3723194,11 C26.0073622,13.0360337 24,16.2767207 24,20.6909162",
    id: "Fill-113",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6769405,40 L82.5716801,40 C77.2922857,40 73,34.7357047 73,28.2648361 C73,21.8304678 77.2455033,16.5886695 82.4827935,16.5301314 L129.973952,7.01711904 C130.437098,6.92437636 130.888548,7.21775545 130.982113,7.67205689 C131.078017,8.12658788 130.77861,8.5703295 130.315464,8.66307219 L82.6558884,18.2093709 L82.5716801,18.2093709 C78.2372903,18.2093709 74.712236,22.7202467 74.712236,28.2648361 C74.712236,33.7653499 78.1811514,38.2484487 82.4687588,38.3193831 L129.354085,26.7148395 C129.810214,26.6016659 130.278038,26.8739254 130.392655,27.3238651 C130.509611,27.7735754 130.231255,28.2299428 129.772788,28.3435756 L82.6769405,40",
    id: "Fill-114",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8987374,10.1204498 L80.4169029,14.0423079 L111.687853,7.87750582 L74.946064,3.95769209 L45.8987374,10.1204498 Z M80.4589683,15 L40,10.4034869 L74.8946507,3 L74.9741076,3.00840479 L118,7.59855756 L80.4589683,15 L80.4589683,15 Z",
    id: "Fill-115",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,16.4964745 C79,16.4964745 72.2334953,19.9722724 72.4016224,28.2483564 C72.5648762,36.2069637 77.308983,40 77.308983,40 L70.8787324,38.5103383 C70.8787324,38.5103383 68.1643333,34.8672215 68.0035161,27.917294 C67.8329525,20.6343973 73.9245123,16 73.9245123,16 L79,16.4964745",
    id: "Fill-116",
    fill: "#393E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8118137,11 C31.8118137,11 26.2758921,14.4487993 26.0126082,21.7518027 C25.6904043,30.6840476 31.6505958,32.3382993 31.6505958,32.3382993 L35.0336204,33 C35.0336204,33 29.5563867,29.8570408 29.7176046,21.5864966 C29.8400839,15.3020073 36,11.6617007 36,11.6617007 L31.8118137,11",
    id: "Fill-117",
    fill: "#393E4B"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-118",
    fill: "#898F9E",
    points: "89 23.3415062 96.7151197 22 97 31.6584938 93 28.7073117 89.8569761 33 89 23.3415062"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-119",
    fill: "#586179",
    points: "125 43.4230438 125 55 128.621375 49.0768947 132 52.8462106 131.759458 41 125 43.4230438"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooks);
export default __webpack_public_path__ + "static/media/icon-books.26276e74.svg";
export { ForwardRef as ReactComponent };